// Mock data pour le site d'apiculture urbaine

export const blogArticles = [
  {
    id: 1,
    title: "Top 5 des Fleurs pour Abeilles Urbaines",
    excerpt: "Découvrez les meilleures plantes mellifères à cultiver sur votre balcon pour nourrir vos abeilles toute l'année.",
    content: "Les abeilles urbaines ont besoin de sources de nectar variées. Voici les 5 meilleures fleurs à planter : lavande, tournesol, cosmos, thym et bourrache. Ces plantes sont faciles à cultiver en pot et fleurissent à différentes saisons.",
    image: "https://images.unsplash.com/photo-1706377164044-df84fb7ade40",
    date: "2025-01-15",
    author: "Marie Dubois",
    category: "Jardinage"
  },
  {
    id: 2,
    title: "Hiverner Votre Ruche de Balcon",
    excerpt: "Guide complet pour préparer votre ruche urbaine à affronter l'hiver en toute sécurité.",
    content: "L'hivernage est crucial pour la survie de la colonie. Réduisez l'entrée de la ruche, vérifiez les réserves de miel (15-20kg nécessaires), isolez si besoin, et surveillez l'humidité. Les abeilles forment une grappe chauffante et consomment leurs réserves.",
    image: "https://images.unsplash.com/photo-1581271064038-11cf1c43a0b2",
    date: "2024-11-20",
    author: "Jean Martin",
    category: "Entretien"
  },
  {
    id: 3,
    title: "Équipement Essentiel du Débutant",
    excerpt: "La liste complète du matériel nécessaire pour démarrer l'apiculture sur votre balcon.",
    content: "Pour débuter, vous aurez besoin de : une ruche adaptée (type Dadant ou Warré), une combinaison d'apiculteur, des gants, un enfumoir, un lève-cadre, et un extracteur de miel. Budget estimé : 300-500€ pour un kit complet de qualité.",
    image: "https://images.unsplash.com/photo-1585327005611-5b4f92570db2",
    date: "2024-10-05",
    author: "Sophie Laurent",
    category: "Équipement"
  },
  {
    id: 4,
    title: "Réglementation de l'Apiculture Urbaine",
    excerpt: "Tout ce qu'il faut savoir sur les lois et règlements concernant les ruches en ville.",
    content: "Avant d'installer une ruche, vérifiez le règlement municipal. En France, les distances légales sont : 5m des habitations et 100m des établissements publics (sauf si mur de 2m de haut). Déclarez votre rucher à la DDPP et obtenez un numéro NAPI.",
    image: "https://images.unsplash.com/photo-1758522965838-a509b49c259d",
    date: "2024-09-12",
    author: "Pierre Durand",
    category: "Réglementation"
  },
  {
    id: 5,
    title: "La Pollinisation en Milieu Urbain",
    excerpt: "Comprendre le rôle crucial des abeilles dans l'écosystème urbain et la biodiversité.",
    content: "Les abeilles urbaines pollinisent jardins, parcs et balcons, contribuant à la biodiversité en ville. Une seule colonie peut visiter jusqu'à 225 millions de fleurs par an. Leur présence favorise la production de fruits et légumes urbains.",
    image: "https://images.unsplash.com/photo-1542936221-b02434e3d36e",
    date: "2024-08-28",
    author: "Claire Rousseau",
    category: "Écologie"
  },
  {
    id: 6,
    title: "Récolter Son Premier Miel Urbain",
    excerpt: "Les étapes pour extraire et mettre en pot votre miel maison en toute simplicité.",
    content: "La première récolte a lieu en juillet-août. Vérifiez que les cadres sont operculés à 80%. Utilisez un extracteur manuel, filtrez le miel, laissez reposer 48h, puis mettez en pot. Rendement moyen : 10-15kg par ruche la première année.",
    image: "https://images.unsplash.com/photo-1675782674767-3220049cc11f",
    date: "2024-07-18",
    author: "Marc Lefebvre",
    category: "Récolte"
  }
];

export const features = [
  {
    icon: 'Flower2',
    title: 'Sauvez les Abeilles',
    description: 'Contribuez à la préservation des pollinisateurs en hébergeant une colonie sur votre balcon.'
  },
  {
    icon: 'Droplets',
    title: 'Miel Local',
    description: 'Récoltez votre propre miel bio, 100% naturel et sans transport. De la ruche à votre table.'
  },
  {
    icon: 'Sprout',
    title: 'Faible Entretien',
    description: "Une ruche urbaine nécessite seulement 10-15 heures d'attention par an. Idéal pour les citadins."
  }
];

export const roadmapSteps = [
  {
    number: 1,
    title: 'Vérifier la Législation',
    description: 'Consultez le règlement municipal et les distances légales requises pour installer une ruche.'
  },
  {
    number: 2,
    title: 'Choisir la Ruche',
    description: 'Optez pour une ruche Dadant ou Warré adaptée aux espaces restreints des balcons urbains.'
  },
  {
    number: 3,
    title: 'Équipement de Protection',
    description: 'Investissez dans une combinaison, des gants, un enfumoir et un lève-cadre de qualité.'
  },
  {
    number: 4,
    title: 'Commander les Abeilles',
    description: "Achetez un essaim ou un nucleus auprès d'un apiculteur local entre avril et juin."
  }
];
